/* particlesJS.load(@dom-id, @path-json, @callback (optional)); */
particlesJS.load('particles-js-left', '/wp-content/themes/tampere-ai/assets/json/particles-config.json');
particlesJS.load('particles-js-right', '/wp-content/themes/tampere-ai/assets/json/particles-config.json');
